import { backgroundOrange, blue, orange } from '@/theme/colors'
import styled from 'styled-components'

export const HeaderContainer = styled.header`
	background: ${backgroundOrange};
	padding: 1rem 2rem;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
	border-bottom: 1px solid #e1e5e9;

	@media (max-width: 600px) {
		padding: 0.625rem 0.875rem;
	}
`

export const HeaderContent = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
`

export const Logo = styled.h1`
	color: #2c3e50;
	font-size: 2rem;
	font-weight: 700;
	margin: 0;

	@media (max-width: 600px) {
		font-size: 1.375rem;
	}
`

export const Nav = styled.nav`
	display: flex;
	gap: 2rem;
`

export const NavLink = styled.a`
	color: white;
	text-decoration: none;
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	transition: all 0.3s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.2);
		transform: translateY(-2px);
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;

	@media (max-width: 600px) {
		gap: 0.375rem;
	}
`

export const BackButton = styled.button`
	background: #f8f9fa;
	color: #495057;
	border: 1px solid #dee2e6;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		background: #e9ecef;
		border-color: #adb5bd;
	}

	@media (max-width: 600px) {
		padding: 0.4rem 0.6rem;
		font-size: 0.8rem;
	}
`

export const MyTripsButton = styled.button`
	background: ${orange};
	color: white;
	border: 1px solid ${orange};
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(209, 95, 42, 0.3);
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.55rem;
		font-size: 0.8rem;
		gap: 0.3rem;
		border-radius: 6px;

		span {
			display: none;
		}
	}
`

export const MyProfileButton = styled.button`
	background: ${orange};
	color: white;
	border: 1px solid ${orange};
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(209, 95, 42, 0.3);
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.55rem;
		font-size: 0.8rem;
		gap: 0.3rem;
		border-radius: 6px;

		span {
			display: none;
		}
	}
`

export const AdminButton = styled.button`
	background: ${blue};
	color: white;
	border: 1px solid ${blue};
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(57, 64, 128, 0.3);
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.6rem;
		font-size: 0.8rem;
		border-radius: 6px;
	}
`

export const LogoutButton = styled.button`
	background: #dc3545;
	color: white;
	border: 1px solid #dc3545;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		background: #c82333;
		border-color: #bd2130;
	}

	@media (max-width: 600px) {
		padding: 0.45rem 0.6rem;
		font-size: 0.8rem;
		border-radius: 6px;
	}
`
